import schema from 'schm';

export default schema({
  isEligibilityLoading: false,
  isEligibilityDisabled: false,
  isEligibilityCreating: false,
});
